import { Type, Static } from '@sinclair/typebox'

import { PermissionSetTB, PermissionValueTB } from './permission'

export const ResourceTypeOrganisationTB = Type.Literal('Organisation')
export const ResourceTypePropertyTB = Type.Literal('Property')
export const ResourceTypeReportTB = Type.Literal('Report')
export const ResourceTypeRelationshipTB = Type.Literal('Relationship')
export const ResourceTypeVisionInvitationTB = Type.Literal('VisionInvitation')
export const ResourceTypeLinkedFarmTB = Type.Literal('LinkedFarm')

export const ResourceTypeTB = Type.Union([
  ResourceTypeOrganisationTB,
  ResourceTypePropertyTB,
  ResourceTypeReportTB,
  ResourceTypeRelationshipTB,
  ResourceTypeVisionInvitationTB,
  ResourceTypeLinkedFarmTB
])
export type ResourceTypeT = Static<typeof ResourceTypeTB>

// N.B. if we ever need "ResourceTB", a Type.Union of all resources, be careful re circular dependencies

// N.B. almost the same as a PermissionsSet, but "create" permissions for a resource specify which child resources can be created (with regard to the specific resource that owns the ResourcePermissionsSet)
export const ResourcePermissionsSetTB = Type.Composite([
  PermissionSetTB,
  // different value for "create" on a specific resource - we state what other "child" resource types can be created with regard to the current resource
  // N.B. no good TypeBox way apparently to just use ResourceTypeTB to specify the child resource types that can be created
  Type.Object({
    create: Type.Optional(Type.Object({
      Organisation: Type.Optional(PermissionValueTB),
      Property: Type.Optional(PermissionValueTB),
      Report: Type.Optional(PermissionValueTB),
      Relationship: Type.Optional(PermissionValueTB),
      VisionInvitation: Type.Optional(PermissionValueTB),
      LinkedFarm: Type.Optional(PermissionValueTB),
    }))
  })
])
export type ResourcePermissionsSetT = Static<typeof ResourcePermissionsSetTB>

export const ResourcePermissionsTB = Type.Object({
  permissions: ResourcePermissionsSetTB,
  resourceId: Type.String(), // uuid
  resourceType: ResourceTypeTB,
  // N.B. same as ExplodedPathTB, but not imported in order to avoid circular dep
  path: Type.Array(Type.Object({
    id: Type.String(), // uuid
    type: ResourceTypeTB
  }))
})
export type ResourcePermissionsT = Static<typeof ResourcePermissionsTB>

export const PermissionsPerResourceTB = Type.Record(
  Type.String(), // uuid
  ResourcePermissionsTB
)
export type PermissionsPerResourceT = Static<typeof PermissionsPerResourceTB>
